var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-6 offset-lg-3 col-12 text-center p-0" },
        [
          _c("div", { staticClass: "card shadow-sm" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("img", {
                staticClass: "img-fluid pa-2",
                attrs: { src: _vm.mergeUrl, alt: "" }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row my-1" }, [
              _c("label", { staticClass: "control-label col-sm-12 h5" }, [
                _vm._v("ลายเซ็นต์ยืนยันตัวตน")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-sm-12",
                  staticStyle: { "text-align": "center" }
                },
                [
                  _c("canvas", {
                    ref: "signaturePadBorrower",
                    staticClass: "canvas-box land-signature-pad"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-sm-12 my-2",
                  staticStyle: { "text-align": "center" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-info btn-lg btn-block",
                      on: {
                        click: function($event) {
                          return _vm.clearSignature()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-undo" }),
                      _vm._v(" เขียนลายเซ็นต์ใหม่")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-success btn-lg btn-block",
                      on: {
                        click: function($event) {
                          return _vm.useSignature()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-check" }),
                      _vm._v(" ยืนยันลายเซ็นต์่")
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("p", { staticClass: "text-center", staticStyle: { margin: "0px" } }, [
        _vm._v("ผู้กู้สินเชื่อ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body" }, [
      _c("p", { staticClass: "h6" }, [
        _vm._v(
          "กรุณายืนยันตัวตนผู้กู้และผู้คำประกัน เพื่อทำการยื่นขอสินเชื่อเงินสดผ่าน App"
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc604092", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc604092","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nimcap/Components/Borrower/Step6.vue
// module id = 2282
// module chunks = 0